import React, { useEffect, useState } from 'react';
import './Filters.scss';
import PropTypes from 'prop-types';
import { CheckboxList } from '../index';

const Filters = ({
  title,
  subTitle,
  clearFilters,
  setClearFilters,
  checkboxList,
  setFilters,
  unfilteredList,
}) => {
  const [checkBoxes, setCheckboxes] = useState(checkboxList);
  const [noChecked, setNoChecked] = useState(true);

  useEffect(() => {
    const noneSelected = checkBoxes.every((box) => !box.checked);
    if (noneSelected) {
      setFilters(unfilteredList);
      setNoChecked(true);
    } else {
      setNoChecked(false);
    }
  }, [checkBoxes]);

  useEffect(() => {
    if (noChecked) {
      setFilters(unfilteredList);
    }
  }, [unfilteredList]);

  const clearCheckboxes = () => {
    const clearedCheckboxes = checkBoxes.map((box) => ({ ...box, checked: false }));
    setCheckboxes(clearedCheckboxes);
  };

  useEffect(() => {
    if (clearFilters) {
      clearCheckboxes();
      setClearFilters(false);
    }
  }, [clearFilters]);

  const getFiltered = (check) => {
    const checkedFilters = check.filter((item) => item.checked);
    const filtered = checkedFilters.map((item) =>
      unfilteredList.filter((filteredItem) => item.value === filteredItem.testStatus)
    );
    return [].concat(...filtered);
  };

  const onCheck = (e) => {
    const check = checkBoxes.map((item) => {
      if (item.id === Number(e.target.name)) {
        item.checked = e.target.checked;
      }
      return item;
    });

    setCheckboxes(check);
    const regs = getFiltered(check);
    setFilters(regs);
  };

  const onClear = () => {
    clearCheckboxes();
    setFilters(unfilteredList);
  };

  return (
    <div className="filters-container">
      <div className="filters-header">
        <div className="filters-title">{title}</div>
        <div className="filters-clear" onClick={onClear}>
          {!noChecked && 'Clear'}
        </div>
      </div>
      <div className="filters-content">
        <CheckboxList onChange={onCheck} checkboxes={checkBoxes} title={subTitle} />
      </div>
    </div>
  );
};

export default Filters;

Filters.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  clearFilters: PropTypes.func,
  setFilters: PropTypes.func,
};

Filters.defaultProps = {};
